const actions = {
    GET_PLAN_WISE_MAPPING: "GET_PLAN_WISE_MAPPING",
    GET_PLAN_WISE_MAPPING_SUCCESS: "GET_PLAN_WISE_MAPPING_SUCCESS",
    GET_PLAN_WISE_MAPPING_FAILED: "GET_PLAN_WISE_MAPPING_FAILED",
    GET_ALL_PLAN_PRICE_MAPPING_DATA: "GET_ALL_PLAN_PRICE_MAPPING_DATA",
    GET_ALL_PLAN_PRICE_MAPPING_DATA_SUCCESS: "GET_ALL_PLAN_PRICE_MAPPING_DATA_SUCCESS",
    GET_ALL_PLAN_PRICE_MAPPING_DATA_FAILED: "GET_ALL_PLAN_PRICE_MAPPING_DATA_FAILED",
    UPDATE_PLAN_PRICE_MAPPING_DATA: "UPDATE_PLAN_PRICE_MAPPING_DATA",
    UPDATE_PLAN_PRICE_MAPPING_DATA_SUCCESS: "UPDATE_PLAN_PRICE_MAPPING_DATA_SUCCESS",
    UPDATE_PLAN_PRICE_MAPPING_DATA_FAILED: "UPDATE_PLAN_PRICE_MAPPING_DATA_FAILED",
    RESET_PLAN_PRICE_MAPPING_MESSAGES: "RESET_PLAN_PRICE_MAPPING_MESSAGES",
    GET_RECHARGE_MAPPING_DATA: "GET_RECHARGE_MAPPING_DATA",
    GET_RECHARGE_MAPPING_DATA_SUCCESS: "GET_RECHARGE_MAPPING_DATA_SUCCESS",
    GET_RECHARGE_MAPPING_DATA_FAILED: "GET_RECHARGE_MAPPING_DATA_FAILED",
    UPDATE_RECHARGE_MAPPING_DATA: "UPDATE_RECHARGE_MAPPING_DATA",
    UPDATE_RECHARGE_MAPPING_DATA_SUCCESS: "UPDATE_RECHARGE_MAPPING_DATA_SUCCESS",
    UPDATE_RECHARGE_MAPPING_DATA_FAILED: "UPDATE_RECHARGE_MAPPING_DATA_FAILED",
    CHECK_RECHARGE_MAPPING_EXISTS: "CHECK_RECHARGE_MAPPING_EXISTS",
    CHECK_RECHARGE_MAPPING_EXISTS_SUCCESS: "CHECK_RECHARGE_MAPPING_EXISTS_SUCCESS",
    CHECK_RECHARGE_MAPPING_EXISTS_FAILED: "CHECK_RECHARGE_MAPPING_EXISTS_FAILED",
    UPDATE_PLAN_CHILD_PRICE_MAPPING_DATA: "UPDATE_PLAN_CHILD_PRICE_MAPPING_DATA",
    UPDATE_PLAN_CHILD_PRICE_MAPPING_DATA_SUCCESS: "UPDATE_PLAN_CHILD_PRICE_MAPPING_DATA_SUCCESS",
    UPDATE_PLAN_CHILD_PRICE_MAPPING_DATA_FAILED: "UPDATE_PLAN_CHILD_PRICE_MAPPING_DATA_FAILED",
    GET_DAILY_PLAN_MAPPING_DATA: "GET_DAILY_PLAN_MAPPING_DATA",
    GET_DAILY_PLAN_MAPPING_DATA_SUCCESS: "GET_DAILY_PLAN_MAPPING_DATA_SUCCESS",
    GET_DAILY_PLAN_MAPPING_DATA_FAILED: "GET_DAILY_PLAN_MAPPING_DATA_FAILED",
    UPDATE_DAILY_PLAN_MAPPING_DATA: "UPDATE_DAILY_PLAN_MAPPING_DATA",
    UPDATE_DAILY_PLAN_MAPPING_DATA_SUCCESS: "UPDATE_DAILY_PLAN_MAPPING_DATA_SUCCESS",
    UPDATE_DAILY_PLAN_MAPPING_DATA_FAILED: "UPDATE_DAILY_PLAN_MAPPING_DATA_FAILED",
    GET_PORTIN_MAPPING_DATA: "GET_PORTIN_MAPPING_DATA",
    GET_PORTIN_MAPPING_DATA_SUCCESS: "GET_PORTIN_MAPPING_DATA_SUCCESS",
    GET_PORTIN_MAPPING_DATA_FAILED: "GET_PORTIN_MAPPING_DATA_FAILED",
    UPDATE_PORTIN_MAPPING_DATA: "UPDATE_PORTIN_MAPPING_DATA",
    UPDATE_PORTIN_MAPPING_DATA_SUCCESS: "UPDATE_PORTIN_MAPPING_DATA_SUCCESS",
    UPDATE_PORTIN_MAPPING_DATA_FAILED: "UPDATE_PORTIN_MAPPING_DATA_FAILED",

    OPEN_UPDATE_PORTIN_MODAL: "OPEN_UPDATE_PORTIN_MODAL",
    CLOSE_UPDATE_PORTIN_MODAL: "CLOSE_UPDATE_PORTIN_MODAL",


    UPDATE_PORTIN_MAPPING_DATA_BY_DEALERID: "UPDATE_PORTIN_MAPPING_DATA_BY_DEALERID",
    UPDATE_PORTIN_MAPPING_DATA_BY_DEALERID_SUCCESS: "UPDATE_PORTIN_MAPPING_DATA_BY_DEALERID_SUCCESS",
    UPDATE_PORTIN_MAPPING_DATA_BY_DEALERID_FAILED: "UPDATE_PORTIN_MAPPING_DATA_BY_DEALERID_FAILED",

    UPDATE_DAILY_PLAN_MAPPING_BY_DEALERID: "UPDATE_DAILY_PLAN_MAPPING_BY_DEALERID",
    UPDATE_DAILY_PLAN_MAPPING_BY_DEALERID_SUCCESS: "UPDATE_DAILY_PLAN_MAPPING_BY_DEALERID_SUCCESS",
    UPDATE_DAILY_PLAN_MAPPING_BY_DEALERID_FAILED: "UPDATE_DAILY_PLAN_MAPPING_BY_DEALERID_FAILED",

    UPDATE_RECHARGE_MAPPING_BY_DEALERID: "UPDATE_RECHARGE_MAPPING_BY_DEALERID",
    UPDATE_RECHARGE_MAPPING_BY_DEALERID_SUCCESS: "UPDATE_RECHARGE_MAPPING_BY_DEALERID_SUCCESS",
    UPDATE_RECHARGE_MAPPING_BY_DEALERID_FAILED: "UPDATE_RECHARGE_MAPPING_BY_DEALERID_FAILED",

    UPDATE_PLAN_PRICE_MAPPING_BY_DEALERID: "UPDATE_PLAN_PRICE_MAPPING_BY_DEALERID",
    UPDATE_PLAN_PRICE_MAPPING_BY_DEALERID_SUCCESS: "UPDATE_PLAN_PRICE_MAPPING_BY_DEALERID_SUCCESS",
    UPDATE_PLAN_PRICE_MAPPING_BY_DEALERID_FAILED: "UPDATE_PLAN_PRICE_MAPPING_BY_DEALERID_FAILED",

    UPDATE_CHILD_PRICE_MAPPING_BY_DEALERID: "UPDATE_CHILD_PRICE_MAPPING_BY_DEALERID",
    UPDATE_CHILD_PRICE_MAPPING_BY_DEALERID_SUCCESS: "UPDATE_CHILD_PRICE_MAPPING_BY_DEALERID_SUCCESS",
    UPDATE_CHILD_PRICE_MAPPING_BY_DEALERID_FAILED: "UPDATE_CHILD_PRICE_MAPPING_BY_DEALERID_FAILED",


    GET_PLAN_WISE_MAPPING_FOR_DPM: "GET_PLAN_WISE_MAPPING_FOR_DPM",
    GET_PLAN_WISE_MAPPING_FOR_DPM_SUCCESS: "GET_PLAN_WISE_MAPPING_FOR_DPM_SUCCESS",
    GET_PLAN_WISE_MAPPING_FOR_DPM_FAILED: "GET_PLAN_WISE_MAPPING_FOR_DPM_FAILED",

    GET_ALL_PLAN_PRICE_MAPPING_DATA_FOR_DPM: "GET_ALL_PLAN_PRICE_MAPPING_DATA_FOR_DPM",
    GET_ALL_PLAN_PRICE_MAPPING_DATA_FOR_DPM_SUCCESS: "GET_ALL_PLAN_PRICE_MAPPING_DATA_FOR_DPM_SUCCESS",
    GET_ALL_PLAN_PRICE_MAPPING_DATA_FOR_DPM_FAILED: "GET_ALL_PLAN_PRICE_MAPPING_DATA_FOR_DPM_FAILED",

    UPDATE_DEALER_PLAN_MAPPING_FOR_DPM: "UPDATE_DEALER_PLAN_MAPPING_FOR_DPM",
    UPDATE_DEALER_PLAN_MAPPING_FOR_DPM_SUCCESS: "UPDATE_DEALER_PLAN_MAPPING_FOR_DPM_SUCCESS",
    UPDATE_DEALER_PLAN_MAPPING_FOR_DPM_FAILED: "UPDATE_DEALER_PLAN_MAPPING_FOR_DPM_FAILED",

    UPDATE_DEALER_PLAN_MAPPING_FOR_DPM_BY_DEALERID: "UPDATE_DEALER_PLAN_MAPPING_FOR_DPM_BY_DEALERID",
    UPDATE_DEALER_PLAN_MAPPING_FOR_DPM_BY_DEALERID_SUCCESS: "UPDATE_DEALER_PLAN_MAPPING_FOR_DPM_BY_DEALERID_SUCCESS",
    UPDATE_DEALER_PLAN_MAPPING_FOR_DPM_BY_DEALERID_FAILED: "UPDATE_DEALER_PLAN_MAPPING_FOR_DPM_BY_DEALERID_FAILED",


    updateDealerPlanMappingforDPMByDealerId: (dealerId, data, searchData) => ({
        type: actions.UPDATE_DEALER_PLAN_MAPPING_FOR_DPM_BY_DEALERID,
        payload: { dealerId, data, searchData }
    }),
    updateDealerPlanMappingforDPMByDealerIdSuccess: (message) => ({
        type: actions.UPDATE_DEALER_PLAN_MAPPING_FOR_DPM_BY_DEALERID_SUCCESS,
        payload: { message }
    }),
    updateDealerPlanMappingforDPMByDealerIdFailed: (error) => ({
        type: actions.UPDATE_DEALER_PLAN_MAPPING_FOR_DPM_BY_DEALERID_FAILED,
        payload: { error }
    }),


    updateDealerPlanMappingforDPM: (data, searchData) => ({
        type: actions.UPDATE_DEALER_PLAN_MAPPING_FOR_DPM,
        data, searchData
    }),
    updateDealerPlanMappingforDPMSuccess: (message, data) => ({
        type: actions.UPDATE_DEALER_PLAN_MAPPING_FOR_DPM_SUCCESS,
        message, data
    }),
    updateDealerPlanMappingforDPMFailed: (error) => ({
        type: actions.UPDATE_DEALER_PLAN_MAPPING_FOR_DPM_FAILED,
        error
    }),

    getAllPlanPriceMappingDataForDPM: (data) => ({
        type: actions.GET_ALL_PLAN_PRICE_MAPPING_DATA_FOR_DPM,
        payload: { data }
    }),
    getAllPlanPriceMappingDataForDPMSuccess: (data) => ({
        type: actions.GET_ALL_PLAN_PRICE_MAPPING_DATA_FOR_DPM_SUCCESS,
        payload: { data }
    }),
    getAllPlanPriceMappingDataForDPMFailed: (error) => ({
        type: actions.GET_ALL_PLAN_PRICE_MAPPING_DATA_FOR_DPM_FAILED,
        payload: { error }
    }),

    getPlanWiseMappingForDPM: () => ({
        type: actions.GET_PLAN_WISE_MAPPING_FOR_DPM,
    }),
    getPlanWiseMappingForDPMSuccess: (data) => ({
        type: actions.GET_PLAN_WISE_MAPPING_FOR_DPM_SUCCESS,
        payload: { data }
    }),
    getPlanWiseMappingForDPMFailed: (error) => ({
        type: actions.GET_PLAN_WISE_MAPPING_FOR_DPM_FAILED,
        payload: { error }
    }),

    updateChildPriceMappingByDealerId: (dealerId, data, searchData) => ({
        type: actions.UPDATE_CHILD_PRICE_MAPPING_BY_DEALERID,
        payload: { dealerId, data, searchData }
    }),
    updateChildPriceMappingByDealerIdSuccess: (message) => ({
        type: actions.UPDATE_CHILD_PRICE_MAPPING_BY_DEALERID_SUCCESS,
        payload: { message }
    }),
    updateChildPriceMappingByDealerIdFailed: (error) => ({
        type: actions.UPDATE_CHILD_PRICE_MAPPING_BY_DEALERID_FAILED,
        payload: { error }
    }),

    updatePlanPriceMappingByDealerId: (dealerId, data, searchData) => ({
        type: actions.UPDATE_PLAN_PRICE_MAPPING_BY_DEALERID,
        payload: { dealerId, data, searchData }
    }),
    updatePlanPriceMappingByDealerIdSuccess: (message) => ({
        type: actions.UPDATE_PLAN_PRICE_MAPPING_BY_DEALERID_SUCCESS,
        payload: { message }
    }),
    updatePlanPriceMappingByDealerIdFailed: (error) => ({
        type: actions.UPDATE_PLAN_PRICE_MAPPING_BY_DEALERID_FAILED,
        payload: { error }
    }),

    updateRechargeMappingByDealerId: (dealerId, data) => ({
        type: actions.UPDATE_RECHARGE_MAPPING_BY_DEALERID,
        payload: { dealerId, data }
    }),
    updateRechargeMappingByDealerIdSuccess: (message) => ({
        type: actions.UPDATE_RECHARGE_MAPPING_BY_DEALERID_SUCCESS,
        payload: { message }
    }),
    updateRechargeMappingByDealerIdFailed: (error) => ({
        type: actions.UPDATE_RECHARGE_MAPPING_BY_DEALERID_FAILED,
        payload: { error }
    }),

    updateDailyPlanMappingDataByDealerId: (dealerId, data) => ({
        type: actions.UPDATE_DAILY_PLAN_MAPPING_BY_DEALERID,
        payload: { dealerId, data }
    }),
    updateDailyPlanMappingDataByDealerIdSuccess: (message) => ({
        type: actions.UPDATE_DAILY_PLAN_MAPPING_BY_DEALERID_SUCCESS,
        payload: { message }
    }),
    updateDailyPlanMappingDataByDealerIdFailed: (error) => ({
        type: actions.UPDATE_DAILY_PLAN_MAPPING_BY_DEALERID_FAILED,
        payload: { error }
    }),

    openUpdatePortinModal: () => ({
        type: actions.OPEN_UPDATE_PORTIN_MODAL,
    }),

    closeUpdatePortinModal: () => ({
        type: actions.CLOSE_UPDATE_PORTIN_MODAL,
    }),

    updatePortinMappingDataByDealerId: (dealerId, data) => ({
        type: actions.UPDATE_PORTIN_MAPPING_DATA_BY_DEALERID,
        payload: { dealerId, data }
    }),
    updatePortinMappingDataByDealerIdSuccess: (message) => ({
        type: actions.UPDATE_PORTIN_MAPPING_DATA_BY_DEALERID_SUCCESS,
        payload: { message }
    }),
    updatePortinMappingDataByDealerIdFailed: (error) => ({
        type: actions.UPDATE_PORTIN_MAPPING_DATA_BY_DEALERID_FAILED,
        payload: { error }
    }),

    updatePortinMappingData: (data) => ({
        type: actions.UPDATE_PORTIN_MAPPING_DATA,
        payload: { data }
    }),
    updatePortinMappingDataSuccess: (message) => ({
        type: actions.UPDATE_PORTIN_MAPPING_DATA_SUCCESS,
        payload: { message }
    }),
    updatePortinMappingDataFailed: (error) => ({
        type: actions.UPDATE_PORTIN_MAPPING_DATA_FAILED,
        payload: { error }
    }),

    getPortinMapping: () => ({
        type: actions.GET_PORTIN_MAPPING_DATA,
    }),
    getPortinMappingSuccess: (data) => ({
        type: actions.GET_PORTIN_MAPPING_DATA_SUCCESS,
        payload: { data }
    }),
    getPortinMappingFailed: (error) => ({
        type: actions.GET_PORTIN_MAPPING_DATA_FAILED,
        payload: { error }
    }),

    updateDailyPlanMapping: (data) => ({
        type: actions.UPDATE_DAILY_PLAN_MAPPING_DATA,
        payload: { data }
    }),
    updateDailyPlanMappingSuccess: (message) => ({
        type: actions.UPDATE_DAILY_PLAN_MAPPING_DATA_SUCCESS,
        payload: { message }
    }),
    updateDailyPlanMappingFailed: (error) => ({
        type: actions.UPDATE_DAILY_PLAN_MAPPING_DATA_FAILED,
        payload: { error }
    }),

    getDailyPlanMapping: () => ({
        type: actions.GET_DAILY_PLAN_MAPPING_DATA,
    }),
    getDailyPlanMappingSuccess: (data) => ({
        type: actions.GET_DAILY_PLAN_MAPPING_DATA_SUCCESS,
        payload: { data }
    }),
    getDailyPlanMappingFailed: (error) => ({
        type: actions.GET_DAILY_PLAN_MAPPING_DATA_FAILED,
        payload: { error }
    }),

    updatePlanChildPriceMappingData: (data, searchData) => ({
        type: actions.UPDATE_PLAN_CHILD_PRICE_MAPPING_DATA,
        data, searchData
    }),
    updatePlanChildPriceMappingDataSuccess: (message, data) => ({
        type: actions.UPDATE_PLAN_CHILD_PRICE_MAPPING_DATA_SUCCESS,
        message, data
    }),
    updatePlanChildPriceMappingDataFailed: (error) => ({
        type: actions.UPDATE_PLAN_CHILD_PRICE_MAPPING_DATA_FAILED,
        error
    }),

    checkRechargeMappingExists: () => ({
        type: actions.CHECK_RECHARGE_MAPPING_EXISTS,
    }),
    checkRechargeMappingExistsSuccess: (message) => ({
        type: actions.CHECK_RECHARGE_MAPPING_EXISTS_SUCCESS,
        payload: { message }
    }),
    checkRechargeMappingExistsFailed: (error) => ({
        type: actions.CHECK_RECHARGE_MAPPING_EXISTS_FAILED,
        payload: { error }
    }),

    updateRechargeMappingData: (data) => ({
        type: actions.UPDATE_RECHARGE_MAPPING_DATA,
        payload: { data }
    }),
    updateRechargeMappingDataSuccess: (message) => ({
        type: actions.UPDATE_RECHARGE_MAPPING_DATA_SUCCESS,
        payload: { message }
    }),
    updateRechargeMappingDataFailed: (error) => ({
        type: actions.UPDATE_RECHARGE_MAPPING_DATA_FAILED,
        payload: { error }
    }),

    getRechargeMapping: () => ({
        type: actions.GET_RECHARGE_MAPPING_DATA,
    }),
    getRechargeMappingSuccess: (data) => ({
        type: actions.GET_RECHARGE_MAPPING_DATA_SUCCESS,
        payload: { data }
    }),
    getRechargeMappingFailed: (error) => ({
        type: actions.GET_RECHARGE_MAPPING_DATA_FAILED,
        payload: { error }
    }),

    getPlanWiseMapping: (data) => ({
        type: actions.GET_PLAN_WISE_MAPPING,
        payload: { data }
    }),
    getPlanWiseMappingSuccess: (data) => ({
        type: actions.GET_PLAN_WISE_MAPPING_SUCCESS,
        payload: { data }
    }),
    getPlanWiseMappingFailed: (error) => ({
        type: actions.GET_PLAN_WISE_MAPPING_FAILED,
        payload: { error }
    }),
    getAllPlanPriceMappingData: (data) => ({
        type: actions.GET_ALL_PLAN_PRICE_MAPPING_DATA,
        payload: { data }
    }),
    getAllPlanPriceMappingDataSuccess: (data) => ({
        type: actions.GET_ALL_PLAN_PRICE_MAPPING_DATA_SUCCESS,
        payload: { data }
    }),
    getAllPlanPriceMappingDataFailed: (error) => ({
        type: actions.GET_ALL_PLAN_PRICE_MAPPING_DATA_FAILED,
        payload: { error }
    }),
    updatePlanPriceMappingData: (data, searchData) => ({
        type: actions.UPDATE_PLAN_PRICE_MAPPING_DATA,
        data, searchData
    }),
    updatePlanPriceMappingDataSuccess: (message, data) => ({
        type: actions.UPDATE_PLAN_PRICE_MAPPING_DATA_SUCCESS,
        message, data
    }),
    updatePlanPriceMappingDataFailed: (error) => ({
        type: actions.UPDATE_PLAN_PRICE_MAPPING_DATA_FAILED,
        error
    }),
    resetPlanPriceMappingMessages: () => ({
        type: actions.RESET_PLAN_PRICE_MAPPING_MESSAGES,
    })

}
export default actions;